import React from 'react';
import './App.css'; 

const Home = () => {
    return ( 
        <>
        <div className="page-background">
        <img className='logo-image' src="image/logo.jpg" alt="Logo"/>
        <p className="centered-paragraph">
        Mega Genrot is your ultimate Randomizer, Selector, and List Generator. With its powerful algorithms, Mega Genrot empowers you to create random outcomes effortlessly. Whether it's flipping a coin, picking colors from a Hex palette, or selecting names from a vast list, Mega Genrot revolutionizes the way you experience randomness. Download now and explore the endless possibilities!</p>
        <a href='https://apps.apple.com/app/mega-genrot-random-generator/id6444267005'>
        <img className='download-image' src="image/download.svg" alt="download"/>
        </a>
        <a id="privacy-policy-link"><a href='/privacyPolicy' >Privacy Policy</a> | <a href='/termsOfUs' >Terms Of Use</a> | <a href='/accessibilityStatement' >Accessibility Statement</a></a>
        </div>
        </>
     );
}
 
export default Home;